import type { App } from 'vue';
import DS from '@aleph-alpha/ds-components-vue';

export const registerPlugins = (app: App) => {
  app.use(DS as unknown as { install: (app: App) => void });
};
